import { gql } from "@apollo/client";
import { LanControllerLogArgs } from "../../LocationFeedingCalls/GQLCalls/getLanControllerLogs";
import { LanControllerInfo } from "../../LocationFeedingCalls/GQLCalls/getLanControllersCall";
import { DeviceInfo } from "../../..";
import { TerminalInfo } from "../../LocationFeedingCalls/GQLCalls/getTerminalsCall";

export const ATTENTION_FRAGMENT = gql`
  fragment AttentionFields on AttentionLog {
    lan_controller_log_id
    fk_lan_controllers
    timestamp
    level
    type
    message
    fk_terminals
    fk_animals
    fk_systems
    fk_locations
    location_name
    dismissed
    attention_log_id
    additionalInformation {
      lan_controller_cpu_id
      controller_id
      controller_name
      device_cpu_id
      device_id
      device_name
      port
      terminal_type
    }
  }
`

export const GET_ATTENTION_LOGS = gql`
  query AttentionLogs($domain: String!, $input: BasicQueryInfoInput!) {
    controller {
      attentionLogs(domain: $domain, input: $input) {
        ...AttentionFields
      }
    }
  }
  ${ATTENTION_FRAGMENT}
`

export interface AttentionLog extends LanControllerLogArgs {
  fk_systems?: number;
  dismissed: boolean;
  location_name?: string;
  fk_locations?: number;
  attention_log_id: number;
  additionalInformation: AdditionalLogInformation
}

interface AdditionalLogInformation {
  lan_controller_cpu_id?: Pick<LanControllerInfo, "cpu_id">
  controller_id?: Pick<LanControllerInfo, "controller_id">
  controller_name?: Pick<LanControllerInfo, "name">
  device_cpu_id?: Pick<DeviceInfo, "cpu_id">
  device_id?: Pick<DeviceInfo, "device_id">
  device_name?: Pick<DeviceInfo, "name">
  port?: Pick<TerminalInfo, "port">
  terminal_type?: Pick<TerminalInfo, "fk_terminal_types">
}

export interface AttentionLogResponse {
  controller: {
    attentionLogs: AttentionLog[];
  }
}